import React, {Component} from 'react';
import { Button, Form, Message } from 'semantic-ui-react'
import {client} from '../../Client';
import Moment from 'moment'
import {Redirect} from 'react-router-dom';
import 'react-date-picker/index.css'
import {convertNullToEmptyString, arrayToCombo} from '../../Helpers'
import PropTypes from 'prop-types';
import ErrorMessage from '../ErrorMessage'
import PreviewDocumentoForm from "./PreviewDocumentoForm";

class AssegnaDocumentoForm extends Component {
    constructor(props) {
        super(props);
        let fields = convertNullToEmptyString(props.item);
        this.state = {
            movimento: props.item,
            fields: fields,
            fieldErrors: {},
            fieldErrorsText: [],
            inError: false,
            _loading: false,
            errorTitle: '',
            saveSuccess: false,
            error: null,
            dropdownDocumentiLoading: false,
            documentiList: [],
        };
        this.onSaveClick = this.onSaveClick.bind(this)
        this.onInputChange = this.onInputChange.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this)
        this.formIsValid = this.formIsValid.bind(this)
        this.isLoadingInProgress = this.isLoadingInProgress.bind(this)
        this.onDeleteClick = this.onDeleteClick.bind(this)
        this.comboDocumentiList = this.comboDocumentiList.bind(this)
    }

    componentDidMount(){
        this.comboDocumentiList();
    }

    comboDocumentiList(){
        this.setState({ dropdownDocumentiLoading: true });
        client.loadDocumentiAssegnabiliAMovimenti().then((response) => {
            if (response.ok)
            {
                response.json().then((data)=>{
                    this.setState({
                        dropdownDocumentiLoading: false,
                        error: null,
                        documentiList: arrayToCombo(data, "idDocumento", "nome", "idDocumento"),
                    })
                })
            }
            else if (response.status === 401)
            {
                this.props.history.push("/login")
            }            else
            {
                response.json().then((errore) => {
                    let fieldErrorsText = []
                    let fieldErrors = {}
                    this.setState({
                        dropdownDocumentiLoading: false,
                        fieldErrors: fieldErrors,
                        fieldErrorsText: fieldErrorsText,
                        errorTitle: '',
                        error: {title: errore.title, msg: errore.msg},
                        inError: true
                    });
                });
            }
        }).catch((error) => {
            let fieldErrorsText = []
            let fieldErrors = {}
            this.setState({
                dropdownDocumentiLoading: false,
                fieldErrors: fieldErrors,
                fieldErrorsText: fieldErrorsText,
                errorTitle: '',
                error: {title: "Errore di rete imprevisto", msg: error.message},
                inError: true
            });
        });
    }

    onSaveClick(movimento) {
        if (this.props.onSaveClick)
        {
            this.props.onSaveClick(movimento);
        }
    }

    formIsValid(formData) {
        // Validazione dati
        let fieldErrorsText = []
        let fieldErrors = {}

        // Inserire validazioni
        if (formData["nomeDocumento"] === undefined || formData["nomeDocumento"] === "")
        {
            fieldErrors["nomeDocumento"] = true;
            fieldErrorsText.push("Occorre specificare il file da allegare a questo movimento");
        }

        if (Object.keys(fieldErrors).length > 0)
        {
            this.setState({
                fieldErrors: fieldErrors,
                fieldErrorsText: fieldErrorsText,
                errorTitle:"La form contiene errori",
                inError: true
            })
            return false;
        }
        return true;
    }

    onInputChange(a1, {name, value}){
        if (name !== undefined)
        {
            const fields = this.state.fields;
            fields[name] = value;
            this.setState({ fields, fieldErrors: {}, fieldErrorsText:[], errorTitle:'', inError: false });
        }
    }

    handleSubmit(e) {
        e.preventDefault();
        let formData = Object.assign({}, this.state.fields);

        formData["idDocumento"] = this.state.fields.idDocumento;
        formData["idPdc"] = this.state.fields.idPdc.idPdc;
        if (this.state.fields.idCommessa){
            formData["idCommessa"] = this.state.fields.idCommessa.idCommessa;
        }
        formData["creatoDa"] =  this.state.fields.creatoDa.idUtente;

        // Validazione form
        if (!this.formIsValid(this.state.fields)){
            return;
        }

        this.setState({_loading: true});
        client.updateDocumentoInMovimento(
            formData, this.state.fields.idMovimento
        ).then((response) => {
            if (response.ok){
                response.json().then((data) => {
                    this.setState({
                        _loading: false,
                        inError: false,
                        fieldErrors: {},
                        fieldErrorsText: [],
                        // saveSuccess: true,
                        // attivitaSaved: data,
                    });
                    this.onSaveClick(data);
                })
            }
            else if (response.status === 401)
            {
                this.props.history.push("/login")
            }            else
            {
                response.json().then((error) => {
                    let fieldErrorsText = []
                    let fieldErrors = {}

                    if (error.errors !== undefined){
                        Object.keys(error.errors).map((item) => {
                            fieldErrors[item] = true;
                            fieldErrorsText = fieldErrorsText.concat(item + ":" +error.errors[item]);
                            return 0;
                        });
                    }
                    else {
                        fieldErrorsText = [error.message]
                    }
                    this.setState({
                        _loading: false,
                        fieldErrors: fieldErrors,
                        fieldErrorsText: fieldErrorsText,
                        errorTitle:error.title,
                        inError: true
                    });
                })
            }
        }).catch((error) => {
            this.setState({
                _loading: false,
                fieldErrors: {},
                fieldErrorsText: [error.message],
                errorTitle: "Errore di rete imprevisto",
                inError: true
            });
        });
    }

    onDeleteClick(){

    }

    isLoadingInProgress(){
        return this.state._loading || this.state.dropdownNotaLoading || this.dropdownCommesseLoading;
    }

    onDDNotaLoading(value){
        this.setState({dropdownNotaLoading: value})
    }

    handleCancel(e){
        e.preventDefault();
        this.props.onUndoClick(e)
    }

    onOraAttualeClick(ev, fieldName) {
        ev.preventDefault();
        let fields = Object.assign({}, this.state.fields);
        fields[fieldName] = Moment().format("HH:mm");
        this.setState({fields})
    }

    render() {
        if (this.state.error !== null)
        {
            return (<ErrorMessage title={this.state.error.title} msg={this.state.error.msg} />)
        }

        let formInError = this.state.fieldErrorsText.length > 0;

        if (this.state.saveSuccess || this.state.cancelSuccess){
            return <Redirect to={ {
                pathname: '/app/movimenti',
                state: {
                    from: this.props.location,
                    item: this.state.movimentoSaved,
                },
            }}/>
        }

        let preview = null;
        console.log("Nome doc: ", this.state.fields.nomeDocumento);
        if (this.state.fields.nomeDocumento){
            preview = (<PreviewDocumentoForm
                fileName={this.state.fields.nomeDocumento}
                showButtons={false}
            />);
        }

        return <div style={{height: "100%"}}>
            <div className="ui two column stackable grid" style={{height: "100%"}}>
                <div className="column">
                    <p>Assegna un Documento al Movimento <b>{this.props.item.idMovimento.nomeCompleto}</b>.</p>
                    <p>Scegli il documento da assegnare:</p>

                    <Form onSubmit={this.handleSubmit} error={formInError} loading={this.state._loading} success={this.state.saveSuccess}>

                        <Form.Dropdown width={16} loading={this.state.dropdownDocumentiLoading} placeholder='Scegli il Documento' name='nomeDocumento' fluid search selection options={this.state.documentiList} value={this.state.fields.nomeDocumento}
                                       onChange={this.onInputChange} error={this.state.fieldErrors["nomeDocumento"]} />

                        <Form.Group inline>
                            <Button type='button' loading={this.isLoadingInProgress()} onClick={(ev) => this.handleCancel(ev)}><i className="undo icon"/> Annulla</Button>
                            <Button primary type='submit' loading={this.isLoadingInProgress()}><i className="save icon"/> Salva</Button>
                        </Form.Group>

                        <Message
                            error
                            header={this.state.errorTitle}
                            list={this.state.fieldErrorsText}
                        />
                        <Message
                            success
                            header={this.state.successTitle}
                            content={this.state.successText}
                            icon={"smile"}
                        />

                    </Form>
                </div>
                <div className="column">
                    {preview}
                </div>
            </div>
        </div>
    }
}

AssegnaDocumentoForm.PropTypes = {
    item: PropTypes.object.isRequired, // Il movimento
    onUndoClick: PropTypes.func.isRequired,
    onSaveClick: PropTypes.func.isRequired, // Dopo il salvataggio. Argomenti: movimento - movimento salvato sul db
}

export default AssegnaDocumentoForm;




/** WEBPACK FOOTER **
 ** ./src/components/movimenti/AssegnaDocumentoForm.jsx
 **/